var _defs, _ellipse, _ellipse2, _ellipse3, _ellipse4, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyes2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 354.36 89.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3d3327;\n      }\n      .cls-2 {\n        fill: #fff;\n      }\n      .accent {\n        fill: #534741;\n      }\n    "))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 288.57,
    cy: 42.43,
    rx: 64.79,
    ry: 41.43
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 289.57,
    cy: 48.21,
    rx: 64.79,
    ry: 41.43
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 64.79,
    cy: 41.43,
    rx: 64.79,
    ry: 41.43
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 64.79,
    cy: 46.44,
    rx: 64.79,
    ry: 41.43
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "accent",
    cx: 283.96,
    cy: 48.21,
    r: 28.21
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "accent",
    cx: 71.28,
    cy: 46.44,
    r: 28.21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes2);
export default __webpack_public_path__ + "static/media/eyes2.e8bf01f0.svg";
export { ForwardRef as ReactComponent };